import React from 'react';
import { motion } from 'framer-motion';

interface PremiumBackgroundProps {
  children: React.ReactNode;
  showLines?: boolean;
}

const PremiumBackground = ({ children, showLines = true }: PremiumBackgroundProps) => {
  return (
    <div className="relative min-h-screen w-full bg-[#050A0F] overflow-hidden">
      {/* Cyberpunk Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Energy Lines */}
        {showLines && (
          <div className="absolute inset-0 opacity-10">
            {[...Array(6)].map((_, i) => (
              <motion.div
                key={i}
                initial={{ x: '-100%' }}
                animate={{ x: '200%' }}
                transition={{
                  duration: 10 + i * 2,
                  repeat: Infinity,
                  ease: "linear",
                  delay: i * 1.5
                }}
                className="absolute h-px w-full bg-gradient-to-r from-transparent via-cyan-500 to-transparent"
                style={{ top: `${15 + i * 15}%` }}
              />
            ))}
          </div>
        )}
        
        {/* Scanner Effect */}
        <motion.div
          animate={{ y: ['0%', '100%', '0%'] }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="absolute inset-x-0 h-32 bg-gradient-to-b from-transparent via-cyan-500/5 to-transparent pointer-events-none z-10"
        />

        {/* Floating Particles */}
        <div className="absolute inset-0">
          {[...Array(15)].map((_, i) => (
            <motion.div
              key={i}
              animate={{
                x: [Math.random() * 100 + '%', Math.random() * 100 + '%'],
                y: [Math.random() * 100 + '%', Math.random() * 100 + '%'],
                opacity: [0, 0.2, 0],
              }}
              transition={{
                duration: 15 + Math.random() * 10,
                repeat: Infinity,
                ease: "linear"
              }}
              className="absolute w-1 h-1 bg-purple-500 rounded-full blur-[1px]"
            />
          ))}
        </div>

        {/* Gradient Orbs */}
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-500/10 rounded-full blur-[120px] pointer-events-none" />
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default PremiumBackground;